import {
    apiRequest,
    mappingBknDetail, 
    mappingBknUpdate,
    mappingBknPositionList,
    mappingBknPositionBknList,
} from "../../../../../services/adapters/kepegawaian/mappingBknService"

class IndexRepository {

    fetchPosition = async (query) => {
        return await apiRequest("get", mappingBknPositionList, {
            params: query
        }, true)
    }

    fetchPositionBkn = async (query) => {
        return await apiRequest("get", mappingBknPositionBknList, {
            params: query
        })
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", mappingBknDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", mappingBknUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository